import { api } from "@/lib/api";
import { emitChange } from "@/lib/offlineStore";

// Guest notes shared by link live as a separate cloud copy. Every poll we send
// our local version plus the version we last agreed on ("base"); the server
// merges in whatever the friend changed (photos, text, checklist) and returns
// the combined note, which we store locally. Nobody's edits get overwritten.
const K_SHARES = "mango.guestShares";
const K_NOTES = "keepflow.notes";
const FIELDS = ["title", "content", "is_checklist", "checklist_items", "color", "images", "attachments"];

const read = (k) => { try { return JSON.parse(localStorage.getItem(k) || "[]"); } catch { return []; } };
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));
const pick = (n) => Object.fromEntries(FIELDS.map((f) => [f, n?.[f] ?? (f === "is_checklist" ? false : f === "title" || f === "content" || f === "color" ? "" : [])]));
const same = (a, b) => JSON.stringify(pick(a)) === JSON.stringify(pick(b));

export const hasGuestShares = () => read(K_SHARES).length > 0;

export function recordGuestShare(note, data) {
  if (!data?.owner_key) return;
  write(K_SHARES, [{ noteId: note.id, token: data.token, ownerKey: data.owner_key, base: pick(note) }, ...read(K_SHARES)]);
}

async function syncOne(rec, notes) {
  const local = notes.find((n) => n.id === rec.noteId);
  if (!local) return { rec, drop: true };
  if (local.trashed) return { rec };
  const base = rec.base || pick(local);
  const changed = !same(local, base);
  let merged;
  try {
    const body = changed ? { ...pick(local), base } : {};
    merged = (await api.post(`/public/share/${rec.token}/edit`, body, { headers: { "X-Owner-Key": rec.ownerKey } })).data;
  } catch (e) {
    return { rec, drop: e?.response?.status === 404 };
  }
  const next = { rec: { ...rec, base: pick(merged) } };
  if (!same(local, merged)) next.patch = { ...pick(merged), updated_at: new Date().toISOString() };
  return next;
}

export async function syncGuestShares() {
  const recs = read(K_SHARES);
  if (!recs.length) return;
  const results = await Promise.all(recs.map((r) => syncOne(r, read(K_NOTES))));
  const patches = results.filter((r) => r.patch);
  if (patches.length) {
    write(K_NOTES, read(K_NOTES).map((n) => {
      const hit = patches.find((p) => p.rec.noteId === n.id);
      return hit ? { ...n, ...hit.patch } : n;
    }));
    emitChange();
  }
  write(K_SHARES, results.filter((r) => !r.drop).map((r) => r.rec));
}
